import { useMapV2LightGallery } from 'components/mapV2/hooks/MapV2LightGallery';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
    imageUrls: string[];
}

export const ContentImages = (props: Props): JSX.Element => {
    const lightGallery = useMapV2LightGallery({ imageUrls: props.imageUrls });

    const isOdd = props.imageUrls.length % 2 === 1;
    const firstRow = (isOdd ? props.imageUrls.slice(0, 1) : props.imageUrls.slice(0, 2)).map(
        (url, i) => ({ imageUrl: url, originalIndex: i })
    );

    // create array of arrays with size 2
    const otherRowsElements = isOdd ? props.imageUrls.slice(1) : props.imageUrls.slice(2);
    const otherRows = otherRowsElements.reduce((acc, curr, i) => {
        const item = { imageUrl: curr, originalIndex: i + firstRow.length };
        if (i % 2 === 0) {
            acc.push([item]);
        } else {
            acc[acc.length - 1].push(item);
        }
        return acc;
    }, [] as { imageUrl: string; originalIndex: number }[][]);

    const rows = [firstRow, ...otherRows];

    return (
        <S_ContentImages className={props.className}>
            {rows.map((images) => (
                <S_Row key={images[0]?.originalIndex}>
                    {images.map((image) => {
                        return (
                            <S_Image
                                $size={images.length === 1 ? 'full' : 'half'}
                                key={image?.originalIndex}
                                $imageUrl={image.imageUrl}
                                onClick={() => lightGallery.open(image?.originalIndex)}
                            />
                        );
                    })}
                </S_Row>
            ))}
            {lightGallery.element}
        </S_ContentImages>
    );
};

const S_ContentImages = styled.div`
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

const S_Row = styled.div`
    display: flex;
    flex-direction: row;
    gap: 15px;
`;

const S_Image = styled.div<{ $imageUrl: string; $size: 'full' | 'half' }>`
    background-image: url(${(props) => props.$imageUrl});
    background-size: cover;
    background-position: center;
    cursor: pointer;
    border-radius: 7px;

    ${(props) =>
        props.$size === 'half' &&
        css`
            height: 100px;
            width: 50%;
        `}
    ${(props) =>
        props.$size === 'full' &&
        css`
            height: 200px;
            width: 100%;
        `}
`;
